import {createApp} from 'vue';

import '@/assets/css/flexbox.css';
import '@/assets/css/common.css';
import '@/assets/scss/app.scss';
import '@/assets/scss/icons.scss';
import '@/assets/scss/app.scss';
import '@/assets/scss/main-style.scss';
import '@/assets/scss/scroller.scss';
import '@/assets/scss/override.scss';
import '@/assets/scss/form.scss';
import '@/assets/scss/btn.scss';
import '@/assets/css/flexbox.css';
import '@/assets/css/common.css';
import 'v3-tour/dist/vue-tour.css';
import '@/assets/scss/voucher-preview.scss';

import App from './App.vue';
import './commons/prototype.js';

const app = createApp(App);

// Khởi tạo pinia
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import {createPinia} from 'pinia';
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);

// Khai báo router
import router from '@/routers/router';
app.use(router);

// Khai báo các plugin dùng chung
import {pluginInstall} from '@/commons/globalPlugin.js';
import {useComponents} from '@/commons/globalComponents.js';
pluginInstall(app);
useComponents(app);

// Sử dụng localize
import i18n from '@/i18ns/i18n.js';
app.use(i18n);

// filter
import {initFilter} from './commons/msFormat';
initFilter(app);

// phím tắt
import {shortKey} from '@/commons/directives/shortkey.js';
app.directive('shortkey', shortKey);

// Đăng ký popup
import {register} from '@/commons/globalPopup.js';
register(app);

import {PromiseDialog} from 'vue3-promise-dialog';
app.use(PromiseDialog);

/** Vue tour step */
import vueTour from 'v3-tour';
app.use(vueTour);

// Thư viện apexchart vẽ dashboard
// ntduong2 4.3.2024
import VueApexCharts from 'vue3-apexcharts';
app.use(VueApexCharts);

app.mount('#app');
